import { cn } from "@/utils/utils";
import "./LoadSpinner.css";

type LoadSpinnerProps = {
  extraClassNames?: string;
};

const LoadSpinner = ({ extraClassNames }: LoadSpinnerProps) => {
  return (
    <div
      className={cn(
        "w-4 h-4 sm:w-6 sm:h-6 border-2 border-grey-500 border-t-gray-700",
        "border-solid rounded-full animate-spin",
        extraClassNames ?? ""
      )}
    ></div>
  );
};

export default LoadSpinner;
